<!-- 明景布控球 -->
<template>
  <div ref="mjVideo" :id="`mj-video${md5}`" class="mj-video">
    <div v-if="!isSupportMJ" class="wrap-tip">
      <!-- <div class="wrap-content">
            <div class="wrap-xiazai" style="color:#999;font-size: 12px;">建议使用IE, 360极速或安全浏览器的兼容模式查看</div>
        </div> -->
      <div class="wrap-tip">
        <div class="wrap-content">
          <div class="wrap-xiazai"><i class="iconfont icon-xiazai3"></i></div>
          <div style="margin-bottom: 10px">
            <div class="wrap-xiazai">
              <a target="__blank" :href="`${deployBaseRoute}public/vendors/iot/XMKVtdClient.exe`" download="" class="clickDwn">点击下载</a>
              <span style="font-size: 14px">监控播放插件</span>
            </div>
          </div>
          <div class="wrap-xiazai" style="color: #999; font-size: 12px">
            <p>WebSocket连接失败！确保电脑已经安装对应应用程序且端口23305启动</p>
            <p>可尝试重启Windows服务！</p>
          </div>
        </div>
      </div>
    </div>
    <div class="mj-video-container" id="obj" v-else>
      <div :class="['mj-video-img-container', options.toolbar ? 'has-toolbar' : '']">
        <img :class="['mj-video-img', options.toolbar ? 'has-toolbar' : '']" ref="mjImg" :src="imgSrc" alt="" srcset="" />
      </div>
      <div class="vp-toolbar" v-if="options.toolbar">
        <button class="vp-vlc-button" type="button" title="Fullscreen" aria-disabled="false" @click="openFullscreen">
          <span class="fullscreen" aria-hidden="true"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { hex_md5 } from './../utils/md5'
import { IS_CHROME, IS_EDGE } from './../utils/browser'
import { newGUID } from './../utils/guid'
import ReconnectingWebSocket from 'reconnecting-websocket'

// http://111.21.2.29:3000/explorer/

export default {
  name: 'MJVideo',
  props: {
    code: String,
    config: String,
    options: {
      type: Object,
      default: () => {
        return {
          toolbar: true
        }
      }
    }
  },
  data() {
    const deployBaseRoute = window.deployBaseRoute || '/';
    return {
      deployBaseRoute,
      isSupportMJ: true,
      dataset: {
        session: '',
        req: ''
      },
      session: '',
      imgSrc: '',
      ws: null,
      ws2: null,
      talkWs: null,
      isFullscreen: false,
      md5: '',
      voiceReq: null
    }
  },
  watch: {
    config: {
      handler(nVal) {
        if (!nVal) {
          return
        }

        this.md5 = hex_md5(nVal)

        this.init()
      },
      immediate: true
    }
  },
  created() {
    this.isSupportMJ = true
    this.checkMJPlugin('ws://127.0.0.1:23350')
  },
  methods: {
    checkMJPlugin(socketURL) {
      let testWS = new WebSocket(socketURL)
      testWS.addEventListener('close', (e) => {})
      testWS.addEventListener('error', () => {
        console.error('测试连接失败！当前环境不支持明景布控球！')
        this.isSupportMJ = false
      })
      testWS.addEventListener('message', () => {})
      testWS.addEventListener('open', () => {
        this.isSupportMJ = true
        testWS.close(3888)
      })
    },
    init() {
      if (!this.config) {
        console.error('请提供明景配置播放')
        return
      }

      if (this.ws2) {
        this.dispose()
      }

      this.md5 = hex_md5(this.config)

      if (this.config) {
        try {
          const configObj = JSON.parse(this.config)
          const sendData = {
            ...configObj,
            name: 'play',
            cmd: 'create',
            req: newGUID(),
            image: 2,
            head: false
          }
          this.$nextTick(() => {
            this.createWebSocket('ws://127.0.0.1:23350', JSON.stringify(sendData))
          })
        } catch (error) {
          console.error(error)
        }
      }
    },
    // 回放切换
    restartWebSocket(socketURL, playData) {
      if (this.ws) {
        this.ws.close()
      }
      if (this.ws2) {
        this.ws2.close()
      }

      setTimeout(() => {
        this.createWebSocket(socketURL, playData)
      }, 1000)
    },
    // OCX业务逻辑开始
    createWebSocket(socketURL, playData) {
      console.log('开始连接websocket', playData)
      try {
        this.ws = new ReconnectingWebSocket(socketURL, [], {
          connectionTimeout: 1000,
          maxRetries: 3
        })
        this.ws.addEventListener('close', () => {
          console.error('ws1连接关闭！')
        })
        this.ws.addEventListener('error', () => {
          console.error('连接失败！')
        })
        this.ws.addEventListener('message', () => {
          let res = JSON.parse(event.data)
          if (res.result === 0) {
            //往23380新建一个ws连接，连接关联session
            let ws_url = 'ws://127.0.0.1:' + res.media
            this.dataset.session = res.session
            this.dataset.req = res.req
            this.session = res.session
            //根据应答端口port建立第二次连接
            this.createWebSocket2(ws_url, res.session)
          } else {
            console.error('播放失败！', res)
          }
        })
        this.ws.addEventListener('open', () => {
          console.log('ws1连接成功')
          ////向后端发送启动实时流请求
          this.ws.send(playData)
        })
      } catch (e) {
        console.error(e)
      }
    },
    createWebSocket2(url_u, session) {
      try {
        this.ws2 = new WebSocket(url_u)
        this.ws2.onclose = function () {
          console.error('ws2连接关闭2')
        }
        this.ws2.onerror = function () {
          console.error('发生异常2')
        }
        this.ws2.onopen = () => {
          //往session对应的ws发送 start指令
          var data2 = JSON.stringify({
            cmd: 'start',
            session: session
          })
          this.ws2.send(data2)
        }
        // ws2.binaryType = 'blob';
        this.ws2.addEventListener('message', (event) => {
          //实时流应答
          this.renderFrame(event.data)
        })
      } catch (e) {
        console.error(e)
        // reconnect(url_u);
      }
    },
    openFullscreen() {
      this.isFullscreen = !this.isFullscreen
      if (!this.isFullScreen) {
        this.$refs.mjVideo.requestFullscreen()
      } else {
        document.exitFullscreen()
      }
    },
    // 开启对讲
    startVoice(data) {
      this.voiceReq = newGUID()
      try {
        console.log(data)
        const configObj = JSON.parse(data)
        const warpData = JSON.stringify({
          ...configObj,
          req: this.voiceReq,
          name: 'talk',
          cmd: 'create',
          image: 3 // 0-RGB 1-YUV 2-bmp 3-JPEG
        })
        this.sendWebSocketTalk(warpData)
      } catch (error) {
        console.error(error)
      }
    },
    sendWebSocketTalk(data) {
      // 调用create启动 端口23350 直接对讲
      if (this.talkWs) {
        console.warn('请不要重复点击对讲')
        return
      }
      this.talkWs = new WebSocket('ws://127.0.0.1:23350')
      this.talkWs.onopen = (ev) => {
        console.log('talkWS成功')
        this.talkWs.send(data)
      }
      this.talkWs.onmessage = function (ev) {
        console.log('talkWSMsg')
      }
    },
    // 停止对讲
    stopVoice() {
      if (!this.talkWs) {
        return
      }
      const data = JSON.stringify({
        req: this.voiceReq,
        name: 'talk',
        cmd: 'destroy'
      })
      this.talkWs.send(data)
      this.talkWs.close()
      this.talkWs = null
    },
    // 开启声音
    openSound() {
      if (!this.ws2) {
        console.error('Socket2连接失败！')
        return
      }
      var data = JSON.stringify({
        cmd: 'on',
        session: this.session
      })
      this.ws2.send(data)
    },
    closeSound() {
      if (!this.ws2) {
        console.error('Socket2连接失败！')
        return
      }
      var data = JSON.stringify({
        cmd: 'off',
        session: this.session
      })
      this.ws2.send(data)
    },
    // dom distory
    listenDestory() {
      const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver

      var observerOptions = {
        childList: true
      }
      // 观察目标子节点的变化，是否有添加或者删除
      var observer = new MutationObserver((mutationsList, observer) => {
        const element = document.getElementById(`mj-video${md5}`)
        if (!element) {
          this.dispose()
        }
      })
      observer.observe(document.body, observerOptions)
    },
    dispose() {
      if (this.ws) {
        this.ws.close()
        this.ws = null
      }
      if (this.ws2) {
        const data2 = JSON.stringify({
          cmd: 'stop',
          session: this.dataset.session * 1
        })
        this.ws2.send(data2)
        this.ws2.close()
        this.ws2 = null
      }

      if(this.talkWs) {
        const data2 = JSON.stringify({
          cmd: 'stop',
          session: this.session * 1
        })
        this.ws2.send(data2)
        this.ws2.close()
        this.ws2 = null
      }
    },
    renderFrame(data) {
      if (!this.$refs.mjImg) {
        return
      }
      this.$refs.mjImg.onload = () => {
        window.URL.revokeObjectURL(this.$refs.mjImg.src)
      }
      this.imgSrc = window.URL.createObjectURL(data)
    }
  }
}
</script>

<style lang="scss" scoped>
.mj-video {
  width: 100%;
  height: 100%;
  .mj-video-container {
    width: 100%;
    height: 100%;
    .mj-video-img-container {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #000;
      .mj-video-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        // filter: progid:dximagetransform.microsoft.basicimage(rotation :2);
        // transform: rotateX(180deg);
      }
      &.has-toolbar {
        height: calc(100% - 30px);
      }
    }
  }
}
</style>